export default __webpack_public_path__ + "static/media/igiv-screenshot-support.b1a81f45.png";